<template>
    <svg class="icon__cross" xmlns="http://www.w3.org/2000/svg" width="27.707" height="27.35" viewBox="0 0 27.707 27.35">
        <polyline points="0.354 0.354 13.675 13.675 0.354 26.997" fill="none" stroke="#fff" stroke-miterlimit="10"/>
        <polyline points="27.354 26.997 14.032 13.675 27.354 0.354" fill="none" stroke="#fff" stroke-miterlimit="10"/>
    </svg>
</template>


<script>
export default {
    name: "icon-cross",
}
</script>